import { render, staticRenderFns } from "./newSchemeDetailsTableHistory.vue?vue&type=template&id=6753304d"
import script from "./newSchemeDetailsTableHistory.vue?vue&type=script&lang=js"
export * from "./newSchemeDetailsTableHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports